module.exports = __webpack_public_path__ + "leader_support.1edb245d.png";